/*
 *
 * Basic Theme
 *
 */

import "./scss/style.scss";

import "./js/accordion";
import "./js/company-performance";
import "./js/left-menu";
import "./js/main-menu";
import "./js/search-form";
import "./js/tooltip";
import "./js/video-component";
import "./js/reciteme";
import "./js/filters";
import "./js/off-page-carousel";
import "./js/related-content-carousel";
import "./js/share";
import "./js/titled-promos";

import "./js/icons/svgxuse.min.js";
require.context("./images", true);
